import router from "@/router/index";
import {ApiService} from './api.service';

export default class UserService extends ApiService {
  constructor() {
    super();
  }

  logout(): Promise<any> {
    return super.postData("logout").then((response) => {

      // Remove Token
      localStorage.removeItem("token");
      router.push('/');


      // Remove User

      // this.$router.go('/');
    }).catch((error) => {
      console.log("Logout Error");
      throw error;
    });
  }
}
